import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '../../../../theming/jssTypes';
import { Select } from '../../atoms/Select/Select';
import { escapeRegExp, removeArrayDuplicates } from '../../../../utils/utils';
import classNames from 'classnames';

const styles = (theme: ThemeType): CssType => ({
  maxHeightWrapper: {
    '& .ant-select-selector': {
      maxHeight: (props: any) =>
        props.maxHeight ? `${props.maxHeight}px` : 'unset',
      overflowY: 'auto',
    },
  },
  customBorder: {
    '& .ant-select-selector': {
      borderRadius: (props: any) =>
        props.borderRadius ? props.borderRadius : undefined,
      borderColor: (props: any) =>
        props.borderColor ? `${props.borderColor} !important` : undefined,
    },
  },
});

class TagsInput extends React.PureComponent<any, any> {
  state = {
    selectedValues: [] as string[],
    searchInput: '',
  };
  tokeniseRegex: RegExp | null = null;

  constructor(props: any) {
    super(props);
    const { tokenSeparators } = props;
    if (tokenSeparators && tokenSeparators.length) {
      this.tokeniseRegex = new RegExp(
        tokenSeparators.map(escapeRegExp).join('|'),
        'gi',
      );
    }
  }

  getSelectedValues = () => {
    const { selectedValues: selectedValuesFromState } = this.state;
    const selectedValues =
      'value' in this.props ? this.props.value || [] : selectedValuesFromState;
    return selectedValues;
  };

  handleChange = (values: any) => {
    const selectedValues = this.getSelectedValues();
    let newValues: String[] = [];
    if (values.length > selectedValues.length) {
      const lastOption = values[values.length - 1];
      const optionsUnfiltered = this.tokeniseRegex
        ? lastOption.split(this.tokeniseRegex)
        : [lastOption];
      const newOptionsToAdd = removeArrayDuplicates(
        optionsUnfiltered.filter(
          (elem: any) => elem && selectedValues.indexOf(elem) === -1,
        ),
      );
      newValues = [...selectedValues, ...newOptionsToAdd];
    } else {
      newValues = values;
    }
    this.setState({ selectedValues: newValues, searchInput: '' });
    this.props.onChange(newValues);
  };

  handleInputChange = (val: any) => {
    this.setState({ searchInput: val });
    if (this.props.onSearch) {
      this.props.onSearch(val);
    }
  };

  render() {
    const {
      mode,
      onChange,
      onSearch,
      tokenSeparators,
      autoFocus,
      notFoundContent,
      maxHeight,
      className,
      classes,
      theme,
      value,
      allowClear,
      disabled,
      borderRadius,
      borderColor,
      ...otherProps
    } = this.props;
    const { searchInput } = this.state;
    const selectedValues = this.getSelectedValues();
    const classesToAdd = classNames(
      className,
      maxHeight && classes.maxHeightWrapper,
      (borderRadius || borderColor) && classes.customBorder,
    );

    return (
      <Select
        mode={'multiple'}
        notFoundContent={''}
        autoFocus={autoFocus}
        onChange={this.handleChange}
        onSearch={this.handleInputChange}
        value={selectedValues}
        className={classesToAdd}
        allowClear={
          allowClear === undefined || allowClear === null ? true : allowClear
        }
        disabled={disabled}
        showSearch={true}
        {...otherProps}
      >
        {searchInput && selectedValues.indexOf(searchInput) === -1 ? (
          <Select.Option key={searchInput} value={searchInput}>
            {searchInput}
          </Select.Option>
        ) : null}
      </Select>
    );
  }
}

export default withStyles(styles, { injectTheme: true })(TagsInput);
